export const STATUS = {
  PUBLIC: 'P',
  WAITING: 'W',
  SAVE: 'S'
} as const;
